/* Molde flutuante — camada de prototipo sobre a secao Camiseta Fungiverso.
   Nao altera a secao. Se algo faltar, a pagina segue funcionando como hoje.

   DVR 28/09/2026 - O OVERSIZED ENTROU AQUI, e a falta dele foi o que quebrou
   o lancamento. Este arquivo conhecia duas modelagens, Unissex e Baby look.
   Numa pagina de produto oversized ele desenhava a camiseta comum, com a
   caixa de impressao da camiseta, o selo UNISSEX e o par de botoes
   "Unissex 72x54 / Baby look 62x48". A peca e outra e as medidas eram de
   outra roupa. Agora existe a terceira modelagem, com area e tabela
   proprias, e a pagina de oversized abre nela. */
(function () {
  'use strict';
  /* As chaves ove| nao vem do template: o template da pagina de produto e
     auto-gerado pelo editor de temas e reescrever ele na mao e pedir para o
     editor desfazer depois. Elas vem do snippets/dvr-vitrine.liquid, que eu
     controlo, em VF_MOLDE_EXTRA, e se juntam aqui. O que ja existia continua
     mandando: EXTRA so acrescenta o que falta. */
  var URLS = {};
  (function () {
    var base = window.VF_MOLDE || {};
    var extra = window.VF_MOLDE_EXTRA || {};
    var k;
    for (k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) URLS[k] = extra[k]; }
    for (k in base) { if (Object.prototype.hasOwnProperty.call(base, k)) URLS[k] = base[k]; }
  })();
  if (!Object.keys(URLS).length) return;

  /* caixas medidas nas imagens de marcacao do Fredy (quadrado, circulo e retangulo
     sobre a peca): a arte encaixa dentro da caixa, ancorada pelo topo e centrada na horizontal.

     A linha Oversized e a area que ele APROVOU em 26/09: frente 40,0 x 56,0 cm,
     peito 15,4 x 18,9 e costas 38,7 x 54,1, em % da base de 1080. */
  var CAIXA = {
    'Unissex':   { Frente:{v:'frente',L:35.000,T:32.037,W:30.000,H:36.852},
                   Peito :{v:'frente',L:55.556,T:29.167,W:13.704,H:16.759},
                   Costas:{v:'costas',L:35.278,T:27.037,W:29.815,H:36.481} },
    'Baby look': { Frente:{v:'frente',L:37.593,T:32.222,W:24.815,H:30.556},
                   Peito :{v:'frente',L:54.352,T:32.037,W:11.574,H:14.259},
                   Costas:{v:'costas',L:38.163,T:25.719,W:23.969,H:29.514} },
    'Oversized': { Frente:{v:'frente',L:33.200,T:28.500,W:33.700,H:47.200},
                   Peito :{v:'frente',L:56.600,T:35.400,W:13.000,H:15.900},
                   Costas:{v:'costas',L:34.600,T:28.300,W:32.600,H:45.600} }
  };
  var PRE = { 'Unissex':'uni', 'Baby look':'bab', 'Oversized':'ove' };
  /* altura x largura em cm, peca deitada. A tabela do oversized e a que ele
     mandou do fabricante, e vai ate XG. */
  var TAB = { 'Unissex':   {P:[70,51],M:[72,54],G:[74,57],GG:[76,60]},
              'Baby look': {P:[60,46],M:[62,48],G:[64,50],GG:[66,52]},
              'Oversized': {P:[74,58],M:[78,60],G:[80,64],GG:[84,68],XG:[87,72]} };

  /* Esta pagina e de um oversized? Quem responde e a propria secao: ela
     imprime "ove":true dentro do .vf-cfg, e o handle e a reserva. Assim nao
     dependo de adivinhar por nome de produto. */
  var CFG0 = null;
  function cfg() {
    if (CFG0 !== null) return CFG0;
    CFG0 = {};
    try {
      var el = document.querySelector('.vf-cfg');
      if (el) CFG0 = JSON.parse(el.textContent) || {};
    } catch (e) { CFG0 = {}; }
    return CFG0;
  }
  var EH_OVE = null;
  function ehOve() {
    if (EH_OVE !== null) return EH_OVE;
    EH_OVE = cfg().ove === true;
    if (!EH_OVE && (location.pathname || '').indexOf('/products/oversized-') === 0) EH_OVE = true;
    return EH_OVE;
  }
  /* endereco do produto irmao, derivado pela secao. Vazio quer dizer que o
     irmao nao existe ou esta em rascunho, e o botao nasce apagado. */
  function urlCam() { return cfg().cam || ''; }
  function urlOve() { return cfg().ove_url || ''; }

  /* Trocar de modalidade AQUI e trocar de produto, ao contrario da camiseta,
     onde unissex e baby look sao a mesma variante. Entao o clique deixa o
     recado que o dvr-abre.js le do outro lado, para a peca abrir na cor e no
     local que a pessoa ja tinha escolhido, e navega. E a mesma ponte que a
     barra da colecao usa. */
  function levaPara(url, mod) {
    if (!url) return;
    try {
      localStorage.setItem('dvr:abre', JSON.stringify({
        mod: mod, loc: locAtual(), cor: corAtual(), t: Date.now()
      }));
    } catch (e) {}
    location.href = url;
  }

  var modelagem = ehOve() ? 'Oversized' : 'Unissex', raiz, aplicando = false, arteClara = null, arteBox = null, arteFina = false;
  var corExtra = null;
  var NOMES = {branco:'Branco', bege:'Bege', rosa:'Rosa', cinza:'Cinza mescla', verde:'Verde',
               vermelho:'Vermelho', marrom:'Marrom', roxo:'Roxo', preto:'Preto'};
  var ORDEM = ['branco','bege','rosa','cinza','verde','vermelho','marrom','roxo','preto'];

  /* ---------- a linha da gaveta, montada num lugar so ----------
     25/09. Existiam dois renderizadores da mesma linha com formatos diferentes:
     este arquivo (bloco rotulado, so na pagina de produto) e o snippet
     dvr-carrinho-modelagem.liquid (paragrafo corrido, em toda pagina). Quem
     escrevia primeiro ganhava, e o cliente via ora um ora outro.

     Agora a fonte unica e o snippet, que carrega em toda pagina e expoe
     window.dvrTom (mapa de cor da peca) e window.dvrLinha (montagem da linha).
     A consulta aqui e TARDIA, no momento da chamada, nunca no parse: se por
     algum motivo o snippet nao tiver rodado, caimos nas copias abaixo, que
     produzem exatamente a mesma marcacao.

     O mapa de cor nasceu aqui porque nao havia nada para reaproveitar: os
     swatches da pagina de produto (.vf-cor, montados pelo vf.js) sao FOTOS da
     peca, nao cor solida, e as option values de Cor na Shopify estao sem
     swatch. Cor fora da lista fica sem ladrilho proprio, no creme padrao. */
  var TOM = { branco:'#f6f4ef', bege:'#d9c9a8', rosa:'#e8b4c0', cinza:'#9ba1a4',
              verde:'#3b5138', vermelho:'#8d2b27', marrom:'#5a4433', roxo:'#47325a',
              marinho:'#1d2a45', preto:'#15161a' };
  function mapaTom(){
    return (window.dvrTom && typeof window.dvrTom==='object') ? window.dvrTom : TOM;
  }
  function tom(cor){ return mapaTom()[slug(cor)] || ''; }
  function htm(s){
    return String(s==null?'':s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function prepDe(loc){
    if(loc==='Costas') return 'nas costas';
    if(loc==='Peito') return 'no peito';
    return loc ? 'na frente' : '';
  }
  /* copia de reserva de window.dvrLinha: mesma ordem, mesmos spans, mesma
     marcacao. "Tecido premium" nao entra na linha visivel; continua gravado
     na propriedade, para o checkout e para o pedido no admin. */
  function linhaLocal(item){
    var p=(item && item.properties)||{};
    var fora={ html:'', fundo:'', borda:false, filtro:'',
               estampa:!!(p['_Arte'] || p['Modelagem']) };
    var mod=p['Modelagem']?String(p['Modelagem']).trim():'';
    var titulo=String((item && item.variant_title)||'').trim();
    var vt=titulo.split(' / ');
    var tres=vt.length>=3;
    var cor=tres?String(vt[0]).trim():'';
    var tam=tres?String(vt[1]).trim():'';
    var loc=tres?String(vt[2]).trim():'';
    var est=p['Cor da estampa']?String(p['Cor da estampa']).trim():'';
    var peca=p['Cor da camiseta']?String(p['Cor da camiseta']).trim():cor;
    fora.fundo=tom(peca);
    fora.borda=slug(peca)==='branco';
    fora.filtro=est==='Branca'?'inv':(est==='Preta'?'esc':'');
    if(!mod) return fora;
    var s='';
    if(!tres && titulo) s+='<span>'+htm(titulo)+'</span>';
    s+='<span>Modelagem: <b>'+htm(mod)+'</b></span>';
    if(tam) s+='<span>Tamanho: <b>'+htm(tam)+'</b></span>';
    if(cor) s+='<span>Cor da camiseta: <b>'+htm(cor)+'</b></span>';
    if(est) s+='<span>Cor da estampa: <b>'+htm(est)+'</b></span>';
    if(loc) s+='<span>Local da estampa: <b>'+htm(prepDe(loc))+'</b></span>';
    fora.html=s;
    return fora;
  }
  function dadosDaLinha(item){
    var f=window.dvrLinha;
    return (typeof f==='function'?f:linhaLocal)(item);
  }

  /* ---------- de quem e a variante ----------
     09/09/2026. O carimbo de Modelagem/_Arte mais abaixo valia para QUALQUER
     item adicionado enquanto esta pagina estivesse aberta: quem estava numa
     camiseta e adicionava o Mix CoguChips pelo carrossel da gaveta levava o
     chips com "Modelagem: Unissex" e a miniatura da estampa - e isso seguia
     para a linha do pedido. Agora so as variantes desta peca sao carimbadas.
     A lista sai do mesmo .vf-cfg que a secao ja imprime para o vf.js. */
  var VARS = null;
  function daPeca(id){
    if (VARS === null){
      VARS = {};
      try {
        var el = document.querySelector('.vf-cfg');
        if (el) (JSON.parse(el.textContent).variants || []).forEach(function(v){ VARS[String(v.id)] = 1; });
      } catch (e) {}
    }
    return !!VARS[String(id)];
  }

  /* so troca a foto depois de confirmar que o arquivo existe;
     enquanto nao existir, a pagina continua exatamente como esta hoje */
  var okCache = {}, reagenda;
  function ok(u){
    if(!u) return false;
    var e = okCache[u];
    if(e===1) return true;
    if(e===0 || e===2) return false;
    okCache[u]=2;
    var im=new Image();
    im.onload=function(){ okCache[u]=1; clearTimeout(reagenda); reagenda=setTimeout(aplica,60); };
    im.onerror=function(){ okCache[u]=0; };
    im.src=u;
    return false;
  }

  function $(s,e){ return (e||document).querySelector(s); }
  function $$(s,e){ return Array.prototype.slice.call((e||document).querySelectorAll(s)); }
  function slug(n){
    return (n||'').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'')
      .trim().split(/[\s\/]+/)[0];
  }
  function corAtual(){
    if(corExtra) return corExtra;
    var b=$('.vf-cor.on:not(.vfm-extra)'); return b?b.dataset.k:'';
  }
  function locAtual(){ var b=$('.vf-loc.on'); return b?b.dataset.k:'Frente'; }
  /* 25/09: o tamanho e o local tambem viram propriedade de linha. A linha que a
     Shopify escreve sozinha no checkout ("Marrom / M / Peito") nao tem rotulo
     em nada, entao quem le rapido nao ve onde a estampa vai. Com rotulo em
     todos os campos, o time passa a ler so a lista de baixo. */
  function tamAtual(){ var b=$('.vf-tam.on'); return b?b.dataset.k:''; }
  function base(cor,loc,mod){
    var cx=CAIXA[mod][loc]; if(!cx) return null;
    var u = URLS[PRE[mod]+'|'+slug(cor)+'-'+cx.v];
    return ok(u) ? u : null;
  }

  /* ---------- estilo ---------- */
  function css(){
    var s=document.createElement('style');
    s.textContent =
      '.vf-sl.float,.vf-loc,.vf-cor i{position:relative}' +
      /* o tema anima e sombreia o img; move o balanco para o slide, senao a arte descola da peca */
      '.vf-sl.float{animation:vffl 6s ease-in-out infinite}' +
      '.vf-sl.float img{animation:none!important}' +
      '.vfm-arte{position:absolute;pointer-events:none;z-index:2;object-fit:contain;filter:none!important}' +
      '.vfm-arte.inv{filter:brightness(0) invert(1)!important}' +
      '.vfm-arte.esc{filter:brightness(0)!important}' +
      '.vfm-mods{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
      '.vfm-mods.vfm-tres{grid-template-columns:1fr 1fr 1fr;gap:6px}' +
      '@media (max-width:379px){.vfm-mods.vfm-tres{grid-template-columns:1fr 1fr}}' +
      '.vfm-mod{border:1px solid var(--line);background:rgba(0,0,0,.2);border-radius:11px;padding:10px 8px;' +
        'cursor:pointer;font-family:inherit;color:var(--mut);position:relative;text-align:center;line-height:1.3}' +
      '.vfm-mod b{display:block;font-size:12.5px;color:var(--txt);font-weight:600}' +
      '.vfm-mod em{font-style:normal;display:block;font-size:9.5px;margin-top:3px}' +
      '.vfm-mod.on{border-color:var(--acc);background:var(--acc14);color:var(--acc)}' +
      '.vfm-mod.on b{color:var(--acc)}' +
      '.vfm-mod.on::after{content:"\\2713";position:absolute;top:6px;right:8px;font-size:12px;color:var(--acc);font-weight:700}' +
      '.vfm-mod.vfm-off{opacity:.42;cursor:default}' +
      '.vfm-mod.vfm-off em{color:var(--acc)}' +
      '.vfm-selo{position:absolute;left:10px;top:10px;z-index:3;font-size:9px;letter-spacing:.11em;padding:3px 8px;' +
        'border-radius:5px;background:rgba(8,11,6,.82);border:1px solid var(--line);color:var(--acc)}' +
      '.vf-cor.vfm-extra em::after{content:" \\00b7 prev";color:var(--acc);font-size:8px}' +
      '.vfm-nota{font-size:10.5px;color:var(--acc);margin:8px 0 0;line-height:1.4}' +
      '.vfm-props{display:block;font-size:11.5px;line-height:1.55;margin-top:3px;opacity:.9}' +
      '.vfm-props span{display:block}' +
      '.vfm-props b{font-weight:600;opacity:1}' +
      '.vfm-mini{background:var(--dvr-cor-camiseta,#f4f0e4);border-radius:10px;overflow:hidden}' +
      '.vfm-mini.dvr-borda{box-shadow:inset 0 0 0 1px rgba(0,0,0,.18)}' +
      '.vfm-arte-mini{width:100%;height:100%;object-fit:contain;padding:13%;box-sizing:border-box}' +
      '.dvr-inv .vfm-arte-mini{filter:brightness(0) invert(1)}' +
      '.dvr-esc .vfm-arte-mini{filter:brightness(0)}';
    document.head.appendChild(s);
  }

  /* ---------- a arte da propria pagina ---------- */
  function arteSrc(){
    var a=$('[data-arte]');
    if(a && (a.currentSrc||a.src)) return a.currentSrc||a.src;
    var h=$('[data-hero]');
    return h ? '' : '';
  }
  var tomCache={};
  function mede(url, cb){
    if(!url) return;
    var c=tomCache[url];
    if(c && c.pronto){ cb(c); return; }
    if(c){ c.fila.push(cb); return; }
    c=tomCache[url]={pronto:false, fila:[cb]};
    var im=new Image(); im.crossOrigin='anonymous';
    im.onload=function(){
      /* precisa de resolucao: em 160px hachura fina vira area cheia e a arte
         de traco e confundida com arte preenchida */
      var N=600;
      try{
        var cv=document.createElement('canvas'); cv.width=N; cv.height=N;
        var x=cv.getContext('2d',{willReadFrequently:true}); x.drawImage(im,0,0,N,N);
        var d=x.getImageData(0,0,N,N).data;
        var x0=N,y0=N,x1=0,y1=0,n=0,L=0,op=0,m=0,S=0;
        for(var i=0;i<d.length;i+=4){
          var al=d[i+3], r=d[i], g=d[i+1], b=d[i+2];
          if(al>30){
            var q=i/4, px=q%N, py=(q/N)|0;
            if(px<x0)x0=px; if(px>x1)x1=px; if(py<y0)y0=py; if(py>y1)y1=py;
            L+=0.2126*r+0.7152*g+0.0722*b; n++;
            if(al>240) op++;
          }
          if(al>128){ m++; S+=Math.max(r,g,b)-Math.min(r,g,b); }
        }
        if(n>20 && x1>=x0 && y1>=y0){
          c.box={x:x0/N, y:y0/N, w:(x1-x0+1)/N, h:(y1-y0+1)/N};
          var lum=L/n, area=Math.max((x1-x0+1)*(y1-y0+1),1);
          /* solidez = fracao de pixel totalmente opaco dentro da caixa do desenho.
             desenho de traco fica <20%; arte preenchida fica >28%.
             saturacao = quanto a arte tem de cor. o filtro achata tudo em uma
             cor so, entao so serve para desenho de traco de tinta unica:
             arte colorida ou com meio-tom perde o desenho e vira mancha. */
          var sol=op/area, sat=m?S/m:255;
          c.lum=lum; c.sol=sol; c.sat=sat;
          c.traco = sol<0.20 && sat<18;
          c.fina  = c.traco && lum<140;   /* escura: inverter sobre peca escura */
          c.clara = c.traco && lum>150;   /* clara: escurecer sobre peca clara */
        } else { c.box=null; c.clara=false; c.fina=false; }
      }catch(e){ c.box=null; c.clara=false; c.fina=false; }
      c.pronto=true; c.fila.forEach(function(f){ f(c); }); c.fila=[];
    };
    im.onerror=function(){ c.box=null; c.clara=false; c.fina=false; c.pronto=true; c.fila.forEach(function(f){ f(c); }); c.fila=[]; };
    im.src=url;
  }
  function mediraArte(src){
    if(arteClara!==null) return;
    mede(src, function(t){ arteBox=t.box; arteClara=t.clara; arteFina=t.fina; aplica(); });
  }
  /* mede() ja guarda o resultado em tomCache, por src. O wrapper do fetch e
     sincrono e nao tem como esperar o callback, entao le daqui. aquece()
     garante que a arte em exibicao ja esteja medida muito antes de alguem
     tocar em ADICIONAR; e de graca, porque mede() nao repete o mesmo src. */
  function monocromatica(url){
    var c=url?tomCache[url]:null;
    return !!(c && c.pronto && (c.fina || c.clara));
  }
  function aquece(){
    var s=arteSrc();
    if(s && !tomCache[s]) mede(s, function(){});
  }

  /* ---------- coloca a arte sobre a peca ---------- */
  function poe(cont, img, cx, escura){
    if(!img || !img.complete || !img.naturalWidth) return;
    var src=arteSrc(); if(!src) return;
    var a=cont.querySelector('.vfm-arte');
    if(!a){ a=document.createElement('img'); a.className='vfm-arte'; a.alt=''; cont.appendChild(a); }
    if(a.getAttribute('src')!==src) a.src=src;
    a.classList.toggle('inv', !!escura && arteFina);
    a.classList.toggle('esc', !escura && arteClara===true);
    var ri=img.getBoundingClientRect(), rc=cont.getBoundingClientRect();
    if(!ri.width) return;
    var ox=ri.left-rc.left, oy=ri.top-rc.top;
    var cw=ri.width*cx.W/100, ch=ri.height*cx.H/100;
    var cl=ox+ri.width*cx.L/100, ct=oy+ri.height*cx.T/100;
    var b=arteBox, nw=a.naturalWidth||1, nh=a.naturalHeight||1;
    if(!b || !a.naturalWidth){
      a.style.left=cl+'px'; a.style.top=ct+'px'; a.style.width=cw+'px'; a.style.height=ch+'px';
      return;
    }
    /* encaixa a AREA DO DESENHO na caixa, ancorada pelo topo e centralizada */
    var aspD=(b.w*nw)/(b.h*nh), dw, dh;
    if(aspD > cw/ch){ dw=cw; dh=cw/aspD; } else { dh=ch; dw=ch*aspD; }
    var iw=dw/b.w, ih=dh/b.h;
    a.style.width  = iw+'px';
    a.style.height = ih+'px';
    a.style.left   = (cl + (cw-dw)/2 - b.x*iw) + 'px';
    a.style.top    = (ct - b.y*ih) + 'px';
  }
  function escuro(cor){
    var s=slug(cor);
    return s==='preto'||s==='marrom'||s==='roxo'||s==='marinho'||s==='verde'||s==='vermelho';
  }

  /* ---------- cores que ainda nao existem como variante ---------- */
  function montaCores(){
    var host=$('.vf-cores'); if(!host) return;
    var tem={};
    $$('.vf-cor', host).forEach(function(b){ if(!b.classList.contains('vfm-extra')) tem[slug(b.dataset.k)]=1; });
    ORDEM.forEach(function(sl){
      if(tem[sl]) return;
      if(host.querySelector('.vfm-extra[data-k="'+NOMES[sl]+'"]')) return;
      var b=document.createElement('button');
      b.type='button'; b.className='vf-cor vfm-extra'; b.dataset.k=NOMES[sl];
      b.innerHTML='<i><img alt=""></i><em>'+NOMES[sl]+'</em>';
      b.addEventListener('click', function(ev){
        ev.stopPropagation();
        corExtra=NOMES[sl];
        $$('.vf-cor').forEach(function(x){ x.classList.toggle('on', x===b); });
        aplica();
      }, true);
      host.appendChild(b);
    });
    if(!host.dataset.vfmLig){
      host.dataset.vfmLig='1';
      host.addEventListener('click', function(ev){
        var alvo=ev.target.closest ? ev.target.closest('.vf-cor') : null;
        if(alvo && !alvo.classList.contains('vfm-extra')){ corExtra=null; setTimeout(aplica,40); }
      }, true);
    }
  }

  /* ---------- passo Modelagem ----------
     Pedido dele, na letra: "a pagina do oversized deveria ser igual as demais
     mesmo, so que no lugar da unissex e baby look ter la a oversized para
     selecionar, e nas que nao tiver oversized ficaria tipo apagado por hora".
     E melhor do que o que eu tinha feito antes, que era um cartao unico
     desabilitado no oversized: assim a modalidade fica no mesmo lugar em toda
     a linha e a pessoa descobre que existe oversized na propria pagina.

     A diferenca que o codigo tem que respeitar: Unissex e Baby look sao a
     MESMA variante, a modelagem vai como propriedade de linha, entao trocar
     entre as duas e so repintar. Oversized e OUTRO produto, com outro preco,
     entao esse botao navega.

     Apagado quando o endereco do irmao vem vazio, que e o que acontece
     enquanto o oversized esta em rascunho. */
  function montaPasso(){
    var primeiro=$('.vf-coli .vf-blk');
    if(!primeiro || $('#vfm-blk')) return;
    var ove=ehOve();
    var blk=document.createElement('div');
    blk.className='vf-blk'; blk.id='vfm-blk';

    var itens=[
      { m:'Unissex',   med:'72 &times; 54 cm no M' },
      { m:'Baby look', med:'62 &times; 48 cm no M' },
      { m:'Oversized', med:'78 &times; 60 cm no M' }
    ];
    var html='';
    for(var i=0;i<itens.length;i++){
      var it=itens[i];
      var aceso = (it.m==='Oversized') ? ove : (!ove && it.m==='Unissex');
      /* precisa sair desta pagina? so quando a modalidade vive no outro produto */
      var leva = '';
      if(ove && it.m!=='Oversized') leva = urlCam();
      if(!ove && it.m==='Oversized') leva = urlOve();
      var morto = (ove && it.m!=='Oversized' && !leva) || (!ove && it.m==='Oversized' && !leva);
      html+='<button type="button" class="vfm-mod'+(aceso?' on':'')+(morto?' vfm-off':'')+'"'+
            ' data-m="'+it.m+'"'+(leva?(' data-ir="'+leva+'"'):'')+(morto?' disabled aria-disabled="true"':'')+'>'+
            '<b>'+it.m+'</b><em>'+(morto?'em breve':it.med)+'</em></button>';
    }

    blk.innerHTML =
      '<div class="vf-ask">1. Modelagem <span class="q">&middot; <b id="vfm-lab">' + (ove ? 'Oversized' : 'Unissex') + '</b></span></div>' +
      '<div class="vf-sub" id="vfm-sub">' + (ove
        ? 'Corte oversized: ombro ca&iacute;do, manga curta ampla e malha mais encorpada. No tamanho de sempre ela fica larga; para ficar ajustada, pegue um n&uacute;mero abaixo.'
        : 'Corte reto, gola fechada. A mesma pe&ccedil;a para todo mundo, do P ao GG.') + '</div>' +
      '<div class="vfm-mods vfm-tres">' + html + '</div>';
    primeiro.parentNode.insertBefore(blk, primeiro);

    $$('.vfm-mod', blk).forEach(function(b){
      if(b.disabled) return;
      b.addEventListener('click', function(){
        var ir=b.getAttribute('data-ir');
        if(ir){ levaPara(ir, b.dataset.m==='Baby look' ? 'bab' : (b.dataset.m==='Oversized' ? 'ove' : 'uni')); return; }
        modelagem=b.dataset.m;
        $$('.vfm-mod', blk).forEach(function(x){ x.classList.toggle('on', x===b); });
        aplica();
      });
    });
    renumera();
  }
  function renumera(){
    var n=1;
    $$('.vf-coli .vf-blk .vf-ask').forEach(function(a){
      var t=a.firstChild;
      if(!t || t.nodeType!==3) return;
      var novo=t.nodeValue.replace(/^\s*\d+\.\s*/, n+'. ');
      if(novo!==t.nodeValue) t.nodeValue=novo;
      n++;
    });
  }

  /* ---------- aplica ---------- */
  function aplica(){
    if(aplicando) return;
    aplicando=true;
    try{
      montaCores();
      aquece();
      var cor=corAtual(), loc=locAtual(), baby=(modelagem==='Baby look'), ove=(modelagem==='Oversized');
      var cx=CAIXA[modelagem][loc]; if(!cx) throw 0;

      var lab=$('#vfm-lab'); if(lab) lab.textContent=modelagem;
      var sub=$('#vfm-sub');
      if(sub && !ove) sub.textContent = baby
        ? 'Mesma malha, corte feminino: gola mais aberta, manga mais curta e 10 cm mais curta que a unissex.'
        : 'Corte reto, gola fechada. A mesma peça para todo mundo, do P ao GG.';

      /* foto principal */
      var hero=$('[data-hero]'), slide=hero?hero.closest('.vf-sl'):null;
      var u=base(cor,loc,modelagem);
      if(hero && u){
        if(hero.getAttribute('src')!==u){ hero.removeAttribute('srcset'); hero.src=u; }
        if(slide){
          poe(slide, hero, cx, escuro(cor));
          var selo=$('.vfm-selo', slide);
          if(!selo){ selo=document.createElement('span'); selo.className='vfm-selo'; slide.appendChild(selo); }
          selo.textContent = ove ? 'OVERSIZED' : (baby ? 'BABY LOOK' : 'UNISSEX');
        }
      }

      /* miniaturas de local */
      $$('.vf-loc').forEach(function(b){
        var k=b.dataset.k, c2=CAIXA[modelagem][k]; if(!c2) return;
        var im=b.querySelector('img'), uu=base(cor,k,modelagem);
        if(im && uu){ if(im.getAttribute('src')!==uu){ im.removeAttribute('srcset'); im.src=uu; } poe(b, im, c2, escuro(cor)); }
      });

      /* miniaturas de cor */
      $$('.vf-cor').forEach(function(b){
        var k=b.dataset.k, cai=b.querySelector('i'), im=cai?cai.querySelector('img'):null;
        var uu=base(k,loc,modelagem);
        if(im && uu){ if(im.getAttribute('src')!==uu){ im.removeAttribute('srcset'); im.src=uu; } poe(cai, im, cx, escuro(k)); }
      });

      /* medidas */
      var T=TAB[modelagem];
      $$('.vf-tam').forEach(function(b){
        var k=b.dataset.k, em=b.querySelector('em');
        if(em && T[k]) em.textContent=T[k][0]+'×'+T[k][1]+' cm';
      });
      var on=$('.vf-tam.on'), med=$('[data-medl]');
      if(med && on && T[on.dataset.k]){
        var m=T[on.dataset.k];
        med.innerHTML='<b>'+m[0]+' cm</b> de altura por <b>'+m[1]+' cm</b> de largura.';
      }

      /* rotulo "modelagem unissex" */
      $$('.vf-ask .q').forEach(function(q){
        var no=q.lastChild;
        if(!no || no.nodeType!==3 || no.nodeValue.indexOf('modelagem')<0) return;
        var alvo = ove ? 'oversized' : (baby ? 'baby look' : 'unissex');
        var novo=no.nodeValue.replace(/modelagem (unissex|baby look|oversized)/i,'modelagem '+alvo);
        if(novo!==no.nodeValue) no.nodeValue=novo;
      });

      /* cor que so existe na previa: mostra, mas nao deixa comprar */
      var add=$('[data-add]'), blocoCor=$('.vf-cores') ? $('.vf-cores').parentNode : null;
      var lcor=$('[data-lcor]');
      if(corExtra){
        if(lcor) lcor.textContent=corExtra;
        if(add && !add.dataset.vfmTxt){ add.dataset.vfmTxt=add.textContent; }
        if(add){ add.setAttribute('disabled',''); add.textContent='cor ainda nao cadastrada'; }
        if(blocoCor){
          var nt=$('.vfm-nota', blocoCor);
          if(!nt){ nt=document.createElement('p'); nt.className='vfm-nota'; blocoCor.appendChild(nt); }
          nt.textContent='As quatro ultimas sao as cores novas: existem como base, ainda nao como variante do produto. Da para ver, nao da para comprar.';
        }
      } else {
        if(add && add.dataset.vfmTxt){ add.removeAttribute('disabled'); add.textContent=add.dataset.vfmTxt; delete add.dataset.vfmTxt; }
        var nt2=blocoCor?$('.vfm-nota', blocoCor):null; if(nt2) nt2.remove();
      }

      /* resumo da barra */
      var res=$('[data-res]');
      if(res){
        var b0=res.textContent.replace(/^(Baby look|Oversized)\s+·\s+/,'');
        if(corExtra) b0=b0.replace(/^[^·]+·/, corExtra+' ·');
        var alvo2=(baby?'Baby look · ':(ove?'Oversized · ':''))+b0;
        if(res.textContent!==alvo2) res.textContent=alvo2;
      }
      renumera();
    }catch(e){}
    aplicando=false;
  }

  /* ---------- modelagem vai junto para o carrinho ---------- */
  var fo=window.fetch;
  if(typeof fo==='function'){
    window.fetch=function(e,c){
      try{
        var u=typeof e==='string'?e:(e&&e.url)||'';
        if(u.indexOf('/cart/add')>=0 && c && typeof c.body==='string'){
          var d=JSON.parse(c.body);
          if(d && d.items && d.items.length){
            var sa=arteSrc();
            d.items.forEach(function(it){
              /* so a propria camiseta leva o carimbo: qualquer outro produto
                 adicionado com esta pagina aberta sai limpo */
              if(!daPeca(it.id)) return;
              it.properties=it.properties||{};
              /* a ordem aqui e a ordem que o checkout e o pedido mostram */
              it.properties['Modelagem']=modelagem;
              var _t=tamAtual();
              if(_t) it.properties['Tamanho']=_t;
              var _c=corAtual();
              if(_c) it.properties['Cor da camiseta']=_c;
              /* so a arte monocromatica (de traco) troca de cor conforme a peca.
                 A colorida nunca muda, entao gravar "Cor da estampa" nela seria
                 informacao errada. Se mede() ainda nao respondeu para este src,
                 nao grava nada: omitir e melhor do que errar. */
              if(_c && monocromatica(sa)) it.properties['Cor da estampa']=escuro(_c)?'Branca':'Preta';
              var _l=prepDe(locAtual());
              if(_l) it.properties['Local da estampa']=_l;
              it.properties['Tecido premium']='algodão penteado com elastano';
              if(sa) it.properties['_Arte']=sa;          /* oculta: serve para montar a miniatura */
            });
            c=Object.assign({},c,{body:JSON.stringify(d)});
          }
        }
      }catch(err){}
      return fo.call(this,e,c);
    };
  }

  /* ---------- gaveta do carrinho ---------- */
  var cacheCarrinho=null, buscando=false, tCart;
  function pegaCarrinho(){
    if(buscando) return;
    buscando=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ cacheCarrinho=c; buscando=false; pintaCarrinho(); })
      .catch(function(){ buscando=false; });
  }
  function pintaCarrinho(){
    if(!cacheCarrinho) return;
    var itens=(cacheCarrinho.items||[]).slice();
    var porChave={};
    itens.forEach(function(it,i){ porChave[it.key]={it:it,i:i}; });
    var usados={};
    $$('#CartDrawer-Dynamic-Wrapper .cart-item-row').forEach(function(linha){
      /* a gaveta as vezes fica com a chave de linha antiga: cai para a variante, na ordem */
      var it=null, e=porChave[linha.dataset.key];
      if(e && !usados[e.i]){ it=e.it; usados[e.i]=1; }
      if(!it){
        var vid=String(linha.dataset.lineItemId||'');
        for(var i=0;i<itens.length;i++){
          if(!usados[i] && String(itens[i].variant_id)===vid){ it=itens[i]; usados[i]=1; break; }
        }
      }
      if(!it) return;
      var d=dadosDaLinha(it);

      /* texto: exatamente a marcacao que o snippet escreve nas outras paginas.
         Nada e gravado sem comparar antes: reescrever igual acordaria os dois
         observadores de DOM sem necessidade. */
      var v=linha.querySelector('.cart-item-variant');
      if(v && d.html){
        if(!v.classList.contains('vfm-props')) v.classList.add('vfm-props');
        if(v.innerHTML!==d.html) v.innerHTML=d.html;
      }

      /* miniatura: a arte da estampa, nao a peca. Ladrilho, contorno e filtro
         saem das mesmas propriedades que o snippet usa, sem medir imagem. */
      var sa=(it.properties||{})['_Arte'], cont=linha.querySelector('.cart-item-image');
      if(!sa || !cont) return;
      if(!cont.classList.contains('vfm-mini')) cont.classList.add('vfm-mini');
      if(cont.style.getPropertyValue('--dvr-cor-camiseta')!==d.fundo){
        if(d.fundo) cont.style.setProperty('--dvr-cor-camiseta', d.fundo);
        else cont.style.removeProperty('--dvr-cor-camiseta');
      }
      cont.classList.toggle('dvr-borda', !!d.borda);
      cont.classList.toggle('dvr-inv', d.filtro==='inv');
      cont.classList.toggle('dvr-esc', d.filtro==='esc');
      var im=cont.querySelector('img');
      if(!im){ im=document.createElement('img'); im.alt=''; cont.appendChild(im); }
      if(im.getAttribute('src')!==sa){ im.removeAttribute('srcset'); im.src=sa; }
      if(im.className!=='vfm-arte-mini') im.className='vfm-arte-mini';
    });
  }

  function ligaCarrinho(){
    var w=document.getElementById('CartDrawer-Dynamic-Wrapper');
    if(!w || w.dataset.vfmLig) return;
    w.dataset.vfmLig='1';
    new MutationObserver(function(){
      /* o snippet mantem um cache vivo do carrinho e pinta no mesmo quadro em
         que a gaveta e desenhada, sem rede. Se ele deu conta, nao ha nada a
         fazer aqui: ir ao /cart.js so atrasaria e repintaria igual. */
      if(typeof window.dvrPinta==='function' && window.dvrPinta()) return;
      clearTimeout(tCart);
      tCart=setTimeout(function(){ cacheCarrinho=null; pegaCarrinho(); }, 220);
    }).observe(w,{childList:true,subtree:true});
    pegaCarrinho();
  }

  /* ---------- liga ---------- */
  function inicia(){
    raiz=$('.vf'); if(!raiz) return;
    css(); montaPasso();
    var s=arteSrc(); if(s) mediraArte(s);
    aplica();
    var t;
    new MutationObserver(function(){
      if(aplicando) return;
      clearTimeout(t); t=setTimeout(aplica,70);
    }).observe(raiz,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','src']});
    window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(aplica,120); });
    window.addEventListener('load',aplica);
    setTimeout(aplica,400); setTimeout(aplica,1200);
    ligaCarrinho(); setTimeout(ligaCarrinho,800); setTimeout(ligaCarrinho,2500);
    document.addEventListener('click',function(){ setTimeout(ligaCarrinho,300); }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',inicia);
  else inicia();
})();